import { FC, ReactNode } from 'react';
import { TbInfoCircle } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import SmallTooltip from '@/shared/components/tooltips/SmallTooltip';

interface ResourceCreationFormLabelProps {
    children: ReactNode;
    help: ReactNode;
}

/**
 * Keeps creation-form guidance available without adding layout-shifting helper
 * copy beneath the associated control.
 */
const ResourceCreationFormLabel: FC<ResourceCreationFormLabelProps> = ({ children, help }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <span
            style={{
                alignItems: 'center',
                color: token.colorTextTertiary,
                display: 'inline-flex',
                fontSize: token.fontSizeSM,
                gap: token.marginXXS,
            }}
        >
            <span>{children}</span>
            <SmallTooltip placement='topLeft' title={help}>
                <span
                    aria-label={`About ${typeof children === 'string' ? children : 'this field'}`}
                    style={{ cursor: 'help', display: 'inline-flex' }}
                    tabIndex={0}
                >
                    <TbInfoCircle aria-hidden style={{ color: token.colorTextTertiary }} />
                </span>
            </SmallTooltip>
        </span>
    );
};

export default ResourceCreationFormLabel;
